import React, {useContext, useEffect, useRef, useState} from "react";
import getMortgage from "../../api-functions/mortgage/getMortgage";
import getMoreItems from "../../api-functions/mortgage/getMoreItems";
import {format, isValid} from "date-fns";
import {App, Skeleton} from "antd";
import {API, Auth, graphqlOperation} from "aws-amplify";
import {performGQL} from "../../api-functions/functions";
import generateMutation from "../../../graphql/generate-mutation";
import {v4} from "uuid"
import {
    createAdminLastViewedMortgage,
    createAdminMortgageUploadVerifiedPoint,
    createUserMortgageUploadStatementBalance
} from "../../../graphql/mutations";
import dayjs from "dayjs";
import {Sidebar} from "../SidebarProvider";
import {capitaliseWords} from "../../../assets/scripts/string-functions";
import {expandActiveSubmission} from "../MortgagesProvider";
import {MortgageTypes, ProgressViewState} from "../../../models";

export const Mortgage = React.createContext()
export const extractTypeAndId = (str) => {

    const pattern = /^(.*?)\[(\w+-\w+-\w+-\w+-\w+)]$/;
    const match = str.match(pattern);
    if (match && match[1] && match[2]) {
        return {
            type: match[1],
            id: match[2]
        };
    }
    return null;
}
export const setItemFromPath = (obj, propertyPath, newValue, methodToSet) => {
    let keys = propertyPath.split('.');
    let currentObj = obj;
    // Traverse the object until the second-to-last key
    if (propertyPath !== "") {
        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i]
            const repeater1 = extractTypeAndId(key)
            if (repeater1) {

                currentObj = currentObj[repeater1.type].find(item => item.id === repeater1.id);
            } else {
                currentObj = currentObj[key];
            }
        }

        // Handle the last key separately to set the new value
        const lastKey = keys[keys.length - 1];
        switch (methodToSet) {
            case 'arrayAdd' :
                currentObj[lastKey].push(newValue)
                break
            case 'objectMerge' :
                const repeater2 = extractTypeAndId(lastKey)
                let indexedObj
                if (repeater2) {
                    indexedObj = currentObj[repeater2.type].find(item => item.id === repeater2.id);
                } else {
                    indexedObj = currentObj[lastKey]
                }
                let valKeys = Object.keys(newValue)
                for (let i = 0; i < valKeys.length; i++) {
                    indexedObj[valKeys[i]] = newValue[valKeys[i]]
                }
                break
            default:
                currentObj[lastKey] = newValue
        }
    } else {
        // operation on mortgage
        let valKeys = Object.keys(newValue)
        for (let i = 0; i < valKeys.length; i++) {
            currentObj[valKeys[i]] = newValue[valKeys[i]]
        }
    }

    return obj;
}
// Shallow-copies every object/array along propertyPath (including the node it
// points at) so setItemFromPath can then be used on the result without
// mutating the previous state
export const cloneAlongPath = (obj, propertyPath) => {
    const root = Array.isArray(obj) ? [...obj] : {...obj}
    if (!propertyPath) {
        return root
    }
    let currentObj = root
    for (const key of propertyPath.split('.')) {
        const repeater = extractTypeAndId(key)
        if (repeater) {
            if (!Array.isArray(currentObj[repeater.type])) {
                break
            }
            const array = [...currentObj[repeater.type]]
            currentObj[repeater.type] = array
            const index = array.findIndex(item => item.id === repeater.id)
            if (index === -1) {
                break
            }
            array[index] = {...array[index]}
            currentObj = array[index]
        } else {
            const next = currentObj[key]
            if (next === null || typeof next !== 'object') {
                break
            }
            currentObj[key] = Array.isArray(next) ? [...next] : {...next}
            currentObj = currentObj[key]
        }
    }
    return root
}
export const getItemFromPath = (obj, propertyPath) => {

    let currentObj = obj;
    if (propertyPath === '') {
        return currentObj
    }
    let keys = propertyPath.split('.');

    keys.forEach((key) => {
        let searchKey = key
        //propertyPath items may contain repeaters like applicant1.debts[adf12ed-23234...]
        let repeater = extractTypeAndId(key)

        if (repeater) {
            searchKey = repeater.type
        }
        if (!currentObj) {
            console.log('currentObj is null', {propertyPath})
        }
        if (!currentObj) {
            console.log('currentObj is null', {obj, propertyPath})
        }
        if (currentObj.hasOwnProperty(searchKey)) {
            if (repeater) {
                currentObj = currentObj[searchKey].find(item => item.id === repeater.id);

            } else {
                currentObj = currentObj[searchKey];
            }
        } else {
            currentObj = null
        }
    })

    return currentObj;
}

export const typeCasts = {
    UserMortgageProgress: [{
        requiredRanges: `requiredRanges {
      start
      end
    }`
    }]
}
const buildSelection = (input, defaultReturnItems, typeName) => {
    try {
        const casts = typeCasts[typeName] || []

        // turn array of { field: replacement } into a map
        const castMap = Object.assign({}, ...casts)

        const fields = [
            ...Object.keys(input),
            ...defaultReturnItems,
        ]

        return fields
            .map((field) => castMap[field] || field)
            .join("\n")
    }
    catch (e) {
        console.log('Error building selection string:', e)
    }
}
// AWSJSON comes back as a string, possibly double-encoded
export const parseAwsJson = (value) => {
    if (typeof value !== 'string') return value
    try {
        value = JSON.parse(value)
        if (typeof value === 'string') value = JSON.parse(value)
        return value
    } catch (e) {
        return null
    }
}
export const correctValueForDb = (type, value) => {
    switch (type) {
        case 'gifters':
            return JSON.stringify(value)
        case 'familyMedicalHistory':
        case 'policyConfig':
            return value ? JSON.stringify(value) : null
        case 'textarea' :
            return value.split('\n')
        case 'textareaString' :
            return value
        case 'ddmmyyyy' :
            let st1 = value.split(' / ').reverse().join('-')
            let d1 = new Date(st1)
            if (isValid(d1)) {
                return format(d1, "y-MM-dd")
            }
            return null
        case 'mmyyyy' :
            let st2 = `01 / ${value}`.split(' / ').reverse().join('-')
            let d2 = new Date(st2)
            if (isValid(d2)) {
                return format(d2, "y-MM-dd")
                //return d2.toISOString()
            }
            return null
        case 'datepicker':
            const date = dayjs(value)
            if (dayjs.isDayjs(date) && date?.isValid()) {
                return date.format('YYYY-MM-DD')
            }

            return null
        case 'agearray' :
            return value.map(d => {
                // let st3 = d.split(' / ').reverse().join('-')
                let d3 = d//dayjs(st3)
                if (dayjs.isDayjs(d3) && d3?.isValid()) {
                    return d3.format("YYYY-MM-DD")
                }
                return null
            })
        case 'date':

            return value.format('YYYY-MM-DD')
        case 'paragraphs':
            return value.split('\n').map(t=>`<p>${t}</p>`).join('')

        default:
            return value
    }
}
export const correctValueForSys = (mortgage, question, value) => {
    if (question.answer.type === 'agearray') {
        // ensure the fields match the count
        if (!value) {
            // let parts = question.target.split('.')
            // parts.pop()
            // parts.push('countDependents')
            // let cD = getItemFromPath(mortgage, parts.join('.'))
            // if (parseInt(cD) > 0) {
            //     value = Array(cD).fill(null)
            // }
            value = [null]
        } else {
            value = value.map(iso => dayjs(iso))
        }
    }
    if (['familyMedicalHistory', 'policyConfig'].includes(question.answer.type)) {
        value = parseAwsJson(value)
    }
    if (value && value !== false) {
        if (question.answer.type === 'gifters') {
            value = JSON.parse(value)
        }
        if (question.answer.type === 'ddmmyyyy') {
            value = value.split("-").reverse().join(" / ")
        }
        if (question.answer.type === 'date') {
            value = dayjs(value, 'YYYY-MM-DD')
        }
        if (question.answer.type === 'mmyyyy') {
            value = dayjs(value).format("MM / YYYY")
        }
        if (question.answer.type === 'datepicker') {
            value = dayjs(value, 'YYYY-MM-DD')
        }
        if (question.answer.type === 'textarea' && Array.isArray(value)) {
            value = value.join('\n')
        }
        if (question.answer.type === 'paragraphs') {

            value = value.replace(/<\/p>\s*<p>/gi, '\n')
                // Remove remaining <p> and </p>
                .replace(/<\/?p>/gi, '')
                // Trim surrounding whitespace
                .trim();
        }
    }

    return value
}
export const readAccessGroup = (mortgage, path) => {
    if (path.startsWith('applicant1.')) {
        return [
            `${mortgage.id}-app1`, `${mortgage.id}-app2-read`
        ]
    }
    if (path.startsWith('applicant2.')) {
        return [
            `${mortgage.id}-app2`, `${mortgage.id}-app1-read`
        ]
    }
    return [
        `${mortgage.id}-app1`, `${mortgage.id}-app2`
    ]
}
export const editAccessGroup = (mortgage, path) => {
    if (path.startsWith('applicant1.')) {
        return [
            `${mortgage.id}-app1`, `${mortgage.id}-app2-edit`
        ]
    }
    if (path.startsWith('applicant2.')) {
        return [
            `${mortgage.id}-app2`, `${mortgage.id}-app1-edit`
        ]
    }
    return [
        `${mortgage.id}-app1`, `${mortgage.id}-app2`
    ]
}

function getModelName(path) {

    let repeaterPath = extractTypeAndId(path)
    if (repeaterPath) {

        path = repeaterPath.type
    }

    switch (path) {
        case "" :
            return 'UserMortgage'
        case "mpi":
            return 'AdminMortgageProtectionInsurance'
        case "aiResponses":
            return "AdminMortgageAIResponse"
        case "appointments":
            return 'UserMortgageAppointment'
        case "analysedSections":
            return 'AdminTextractedSections'
        case "submissions":
            return 'UserMortgageSubmission'
        case "docContents":
            return 'AdminMortgageDocumentContent'
        case "playgroundTests" :
            return 'AdminMortgageLenderTestPlaygroundTest'
        case "lenderTests" :
            return 'AdminMortgageLenderTest'
        case "replyRequests" :
            return "AdminEmailReplyRequest"
        case "notifications" :
            return 'AdminMortgageStageNotifications'
        case "queries":
            return 'UserMortgageQuery'
        case "properties" :
            return 'UserMortgagePropertyOnMortgage'
        case "invitations" :
            return 'UserMortgageInvitation'
        case "progress" :
            return 'UserMortgageProgress'
        case "uploads" :
            return 'UserMortgageUploads'
        case "dynamicSections" :
            return 'UserMortgageDynamicSection'
        case "requirement" :
            return 'UserMortgageRequirement'
        case "property" :
            return 'UserMortgageProperty'
        case "existing" :
            return 'UserMortgageExisting'
        case "needs" :
            return 'UserMortgageNeeds'
        case "notes" :
            return 'AdminMortgageNotes'
        case "settings" :
            return 'AdminMortgageSettings'
        case "solicitor" :
            return 'UserMortgageSolicitor'
        case "tasks" :
            return 'AdminMortgageTasks'
        case "stageTasks" :
            return 'AdminMortgageStageTask'
        case "UserMortgageDocuments":
            return 'UserMortgageDocuments'
        case "applicant1" :
        case "applicant2" :
            return 'UserApplicant'
        case "applicant1.employmentIncome":
        case "applicant2.employmentIncome":
            return 'UserApplicantEmploymentIncome'
        case "applicant1.accounts":
        case "applicant2.accounts":
            return 'UserApplicantCurrentAccount'
        case "applicant1.personal" :
        case "applicant2.personal" :
            return 'UserApplicantPersonal'
        case "applicant1.health":
        case "applicant2.health":
            return "UserApplicantHealth"
        case "applicant1.income" :
        case "applicant2.income" :
            return 'UserApplicantIncome'
        case "applicant1.financial" :
        case "applicant2.financial" :
            return 'UserApplicantFinancial'
        case "applicant1.employment" :
        case "applicant2.employment" :
            return 'UserApplicantEmployment'
        case "applicant1.tax" :
        case "applicant2.tax" :
            return 'UserApplicantTax'
        case "applicant2.emails" :
            return 'AdminEmails'
        case "applicant1.emails" :
        case "applicant1.assets":
        case "applicant2.assets":
            return 'UserApplicantAsset'
        case "applicant1.debts":
        case "applicant2.debts":
            return 'UserApplicantDebt'
        case "applicant1.properties":
        case "applicant2.properties":
            return 'UserApplicantProperty'
        case "applicant1.businessAccounts":
        case "applicant2.businessAccounts":
            return 'UserApplicantBusinessCurrentAccount'
        case "applicant1.alternateEmailAddresses":
        case "applicant2.alternateEmailAddresses":
            return 'UserApplicantAlternateEmailAddresses'
        default:
            throw new Error('Unknown model path: ' + path)
    }
}

const addMortgageToLastViewedList = async (mortgageId) => {
    const user = await Auth.currentAuthenticatedUser()
    const input = {
        mortgageID: mortgageId,
        lastViewedOn: new Date().toISOString(),
        lastViewedBy: user.attributes.sub
    }
    await performGQL({input}, createAdminLastViewedMortgage)
}
const vitalAttributesForSync = {
    "UserMortgageAppointment": ["mortgageID", "appointmentDate"],
    "AdminTextractedSections": ["mortgageID"],
    "PublicCouncils": [
        "fullName", "shortName"
    ],
    "AdminPdfOverlayTemplate": [
        "lender", "lenderCode"
    ],
    "AdminPdfOverlayTemplateItem": [
        "name", "pageNo", "x", "y", "type", "templateId"
    ],
    "AdminEmails": [
        "userapplicantID"
    ],
    "AdminEmailAttachments": [
        "adminemailsID"
    ],
    "AdminMortgageTasks": [
        "usermortgageID"
    ],
    "AdminMortgageNotes": [
        "usermortgageID"
    ],
    "AdminMortgageStageTask": [
        "mortgageID", "name"
    ],
    "AdminMortgageStageNotifications": [
        "mortgageID", "name"
    ],
    "AdminMortgageDocumentContent": [
        "mortgageID"
    ],
    "AdminLastViewedMortgage": [
        "mortgageID", "lastViewedOn", "lastViewedBy"
    ],
    "UserMortgageQuery": [
        "mortgageID", "userAnswered", "adminAnswered"
    ],
    "UserMortgageInvitation": [
        "mortgageID", "applicant2ID"
    ],
    "UserMortgageDocuments": [
        "mortgageID"
    ],
    "UserMortgageProgress": [
        "mortgageID"
    ],
    "UserMortgageProgressNotes": [
        "userMortgageProgressID"
    ],
    "UserMortgageDynamicSection": [
        "mortgageID"
    ],
    "UserMortgageUploads": [
        "analysisJobStatus",
        "analysisErrors",
        "contentType",
        "createdAt",
        "editAccessGroup",
        "examined",
        "exclude",
        "fileExtension",
        "fileName",
        "fileSize",
        "id",
        "identityID",
        "index",
        "logicalName",
        "mortgageID",
        "observeMID",
        "omit",
        "owner",
        "pdffed",
        "readAccessGroup",
        "reason",
        "section",
        "seenBy",
        "seenOn",
        "stage",
        "stampedOn",
        "status",
        "statusBy",
        "statusOn",
        "updatedAt",
    ],
    "UserMortgageSubmission": [
        "mortgageID",
        "lenderCode",
        "provisionalRateId",
        "soft",
        "aipExpiryDate",
        "aipSettings",
        "loanOfferExpiryDate",
        "loanOfferSettings",
        "drawdownDate",
        "completedFlowItems",
        "completedFlowItemsForAdmin",
    ],
    "UserApplicantCurrentAccount": [
        "applicantID"
    ],
    "UserApplicantAsset": [
        "applicantID"
    ],
    "UserApplicantDebt": [
        "applicantID"
    ],
    "UserApplicantProperty": [
        "applicantID"
    ],
    "UserApplicantAlternateEmailAddresses": [
        "applicantID"
    ],
    "UserApplicantActivity": [
        "actionedBy", "applicantID"
    ]
}

// Local state can hold a stale _version when something outside this tab
// (e.g. a Lambda writing via IAM) updated the row and our filtered
// subscription never delivered it. AppSync rejects that with
// ConflictUnhandled but hands back the server's current row, so retry once
// with its _version.
const performGQLWithConflictRetry = async (variables, query) => {
    try {
        return await performGQL(variables, query)
    } catch (e) {
        const conflict = e?.errors?.find(err => err.errorType === 'ConflictUnhandled')
        const serverVersion = conflict?.data?._version
        if (!serverVersion || serverVersion === variables.input._version) {
            throw e
        }
        return await performGQL({
            ...variables,
            input: {...variables.input, _version: serverVersion}
        }, query)
    }
}

function MortgageProvider(props) {

    const sidebar = useContext(Sidebar)
    const app = App.useApp()
    const [mortgage, setMortgage] = useState(false)
    // always the latest rendered mortgage - read by optimisticMutate so it can
    // plan and fire requests outside of a setMortgage updater
    const latestMortgage = useRef(mortgage)
    latestMortgage.current = mortgage
    const [allSectionsLoaded, setAllSectionsLoaded] = useState(false)
    // ON LOAD INITIALISATION

    const fetchMortgage = async () => {
        setMortgage('fetching')

        const domainName = window.location.hostname;
        // if (domainName === 'locaelhost') {
        //     const local = localStorage.getItem('mortgage')
        //     if (local) {
        //         setMortgage(JSON.parse(local))
        //         return
        //     }
        // }
        try {
            const result = await getMortgage(props.id)


            if (result) {
                addMortgageToLastViewedList(props.id)
            }
            const m = prepareMortgageForState(result)

            setMortgage(m)
        } catch (e) {
            console.log(e)
            setMortgage(false)
        }
    }
    const ageFromDate = (date) => {
        if (!date) {
            return null
        }
        let dj = dayjs(date, "YYYY-MM-DD")

        if (dayjs.isDayjs(dj) && !dj?.isValid()) {
            return null
        }
        return dayjs().diff(dj, 'years')
    }
    const prepareMortgageForState = (mortgage) => {

        return {
            ...mortgage,
            applicant1: {
                ...mortgage.applicant1,
                accounts: setAndContinueToPopulate(mortgage, 'applicant1.accounts', mortgage.applicant1.accounts),
                emails: setAndContinueToPopulate(mortgage, 'applicant1.emails', mortgage.applicant1.emails),
                debts: setAndContinueToPopulate(mortgage, 'applicant1.debts', mortgage.applicant1.debts),
                assets: setAndContinueToPopulate(mortgage, 'applicant1.assets', mortgage.applicant1.assets),
                properties: setAndContinueToPopulate(mortgage, 'applicant1.properties', mortgage.applicant1.properties),
                employmentIncome: setAndContinueToPopulate(mortgage, 'applicant1.employmentIncome', mortgage.applicant1.employmentIncome),
                businessAccounts : setAndContinueToPopulate(mortgage, 'applicant1.businessAccounts', mortgage.applicant1.businessAccounts),
            },
            applicant2: {
                ...mortgage.applicant2,
                accounts: setAndContinueToPopulate(mortgage, 'applicant2.accounts', mortgage.applicant2.accounts),
                emails: setAndContinueToPopulate(mortgage, 'applicant2.emails', mortgage.applicant2.emails),
                debts: setAndContinueToPopulate(mortgage, 'applicant2.debts', mortgage.applicant2.debts),
                assets: setAndContinueToPopulate(mortgage, 'applicant2.assets', mortgage.applicant2.assets),
                properties: setAndContinueToPopulate(mortgage, 'applicant2.properties', mortgage.applicant2.properties),
                employmentIncome: setAndContinueToPopulate(mortgage, 'applicant2.employmentIncome', mortgage.applicant2.employmentIncome),
                businessAccounts : setAndContinueToPopulate(mortgage, 'applicant2.businessAccounts', mortgage.applicant2.businessAccounts),
            },
            aiResponses: setAndContinueToPopulate(mortgage, 'aiResponses', mortgage.aiResponses),
            figuresTestFlows: setAndContinueToPopulate(mortgage, 'figuresTestFlows', mortgage.figuresTestFlows),
            figuresTests: setAndContinueToPopulate(mortgage, 'figuresTests', mortgage.figuresTests),
            analysedSections: setAndContinueToPopulate(mortgage, 'analysedSections', mortgage.analysedSections),
            submissions: setAndContinueToPopulate(mortgage, 'submissions', mortgage.submissions),
            docContents: setAndContinueToPopulate(mortgage, 'docContents', mortgage.docContents),
            playgroundTests: setAndContinueToPopulate(mortgage, 'playgroundTests', mortgage.playgroundTests),
            lenderTests: setAndContinueToPopulate(mortgage, 'lenderTests', mortgage.lenderTests),
            replyRequests: setAndContinueToPopulate(mortgage, 'replyRequests', mortgage.replyRequests),
            dynamicSections: setAndContinueToPopulate(mortgage, 'dynamicSections', mortgage.dynamicSections),
            uploads: setAndContinueToPopulate(mortgage, 'uploads', mortgage.uploads),
            progress: setAndContinueToPopulate(mortgage, 'progress', mortgage.progress),
            notifications: setAndContinueToPopulate(mortgage, 'notifications', mortgage.notifications),
            properties: setAndContinueToPopulate(mortgage, 'properties', mortgage.properties),
            invitations: setAndContinueToPopulate(mortgage, 'invitations', mortgage.invitations),
            notes: setAndContinueToPopulate(mortgage, 'notes', mortgage.notes),
            queries: setAndContinueToPopulate(mortgage, 'queries', mortgage.queries),
            tasks: setAndContinueToPopulate(mortgage, 'tasks', mortgage.tasks),
            stageTasks: setAndContinueToPopulate(mortgage, 'stageTasks', mortgage.stageTasks),
            UserMortgageDocuments: setAndContinueToPopulate(mortgage, 'UserMortgageDocuments', mortgage.UserMortgageDocuments),
            appointments: setAndContinueToPopulate(mortgage, 'appointments', mortgage.appointments),
        }
    }
    const allDoneCallback = (path) => {
        if (path === 'progress') {
            setAllSectionsLoaded(true)
        }
    }

    const handleUploadWithMoreVerifiedData = async (upload) => {

        const setAdditionalVerifiedData = (path, items) => {
            setMortgage(mort => {
                let origUpload = mort.uploads.find(item => item.id === upload.id)
                let newUpload = {
                    ...origUpload,
                    verifiedData: {
                        ...(origUpload.verifiedData || {}),
                        items: [...(origUpload.verifiedData.items || []), ...items],

                    }
                }
                return {
                    ...mort,
                    uploads: mort.uploads.map(item => {
                        if (item.id === upload.id) {
                            return newUpload
                        }
                        return item
                    })
                }
            })
        }
        if (upload.verifiedData?.nextToken) {
            await getMoreItems({
                uploadID: upload.id,
                nextToken: upload.verifiedData.nextToken
            }, 'additionalVerifiedData', setAdditionalVerifiedData, allDoneCallback)
        }

    }
    const handleUploadWithMoreBalances = async (upload) => {
        const setAdditionalBalances = (path, items) => {

            setMortgage(mort => {
                let origUpload = mort.uploads.find(item => item.id === upload.id)
                let newUpload = {
                    ...origUpload,
                    balances: {
                        ...(origUpload.balances || {}),
                        items: [...(origUpload.balances.items || []), ...items.filter(it => !it._deleted)],

                    }
                }
                return {
                    ...mort,
                    uploads: mort.uploads.map(item => {
                        if (item.id === upload.id) {
                            return newUpload
                        }
                        return item
                    })
                }
            })
        }
        if (upload.balances?.nextToken) {
            await getMoreItems({
                uploadID: upload.id,
                nextToken: upload.balances.nextToken
            }, 'additionalBalances', setAdditionalBalances, allDoneCallback)
        }
    }
    const setAndContinueToPopulate = (mortgage, path, response) => {
        if (response) {
            let {
                items,
                nextToken
            } = response
            //accept and set itital items, and if theres a nextToken, start process to retrieve all
            if (items && path === "uploads") {
                let moreData = items.filter(item => !item._deleted && item.verifiedData?.nextToken)
                if (moreData.length > 0) {

                    moreData.forEach(item => {
                        handleUploadWithMoreVerifiedData(item) // this is an upload with more verified data to fetch
                    })
                }

                let moreData2 = items.filter(item => !item._deleted && item.balances?.nextToken) // this is an upload with more balances to fetch
                if (moreData2.length > 0) {

                    moreData2.forEach(item => {
                        handleUploadWithMoreBalances(item)
                    })
                }
                items.forEach(item => {
                    if (item.verifiedData?.items && item.verifiedData.items.length > 0) {
                        item.verifiedData.items = item.verifiedData.items.filter(it => !it._deleted)
                    }
                    if (item.balances?.items && item.balances.items.length > 0) {

                        item.balances.items = item.balances.items.filter(it => !it._deleted)
                    }

                })
            }
            if (nextToken) {
                switch (path) {
                    case 'aiResponses':
                    case 'appointments':
                    case 'docContents':
                    case 'submissions':
                    case 'playgroundTests':
                    case 'properties':
                    case 'UserMortgageDocuments':
                    case 'invitations':
                    case 'progress':
                    case 'uploads':
                    case 'notifications':
                    case 'lenderTests':
                    case 'figuresTestFlows':
                    case 'figuresTests':
                    case 'dynamicSections':
                        getMoreItems({
                            mortgageID: mortgage.id,
                            nextToken
                        }, path, setItems, allDoneCallback)
                        break
                    case 'applicant1.emails':
                    case 'applicant1.assets':
                    case 'applicant1.debts':
                    case 'applicant1.properties':
                    case 'applicant1.employmentIncome':
                        getMoreItems({
                            applicantID: mortgage.applicant1.id,
                            nextToken
                        }, path, setItems, allDoneCallback)
                        break
                    case 'applicant2.emails':
                    case 'applicant2.assets':
                    case 'applicant2.debts':
                    case 'applicant2.properties':
                    case 'applicant2.employmentIncome':
                        getMoreItems({
                            applicantID: mortgage.applicant2.id,
                            nextToken
                        }, path, setItems, allDoneCallback)
                        break
                    default:
                }
            } else {
                allDoneCallback(path)
            }

            return (items || []).filter(item => !item._deleted)
        }
        return null
    }
    const setItems = (path, items) => {
        let newItems = items

        if (path === 'progress') {
            newItems = newItems.map(item => {
                if (item.notes) {
                    return {
                        ...item,
                        notes: (item.notes.items)
                    }
                }
                return item

            })
        }
        if (path === 'uploads') {
            newItems = newItems.map(item => {
                const newItem = {...item}

                if (item?.verifiedData) {
                    newItem.verifiedData = {
                        ...item.verifiedData,
                        items: (item.verifiedData.items || []).filter(it => !it._deleted)
                    }
                }

                if (item?.balances) {
                    newItem.balances = {
                        ...item.balances,
                        items: (item.balances.items || []).filter(it => !it._deleted)
                    }
                }

                return newItem

            })
        }
        setMortgage(s => {

            let copy = {...s}
            let existingItems = getItemFromPath(s, path)
            setItemFromPath(copy, path, [
                ...existingItems, ...newItems.filter(item => !item._deleted)
            ])
            return copy
        })
    }
    const applicantStrings = (applicant) => {
        const userIsApplicant = false
        const appName = (applicant.firstName ? applicant.firstName : 'the other applicant').trim()
        return {
            I: userIsApplicant ? 'I' : appName,
            you: userIsApplicant ? 'you' : appName,
            areYou: userIsApplicant ? 'are you' : 'is ' + appName,
            doYou: userIsApplicant ? 'do you' : 'does ' + appName,
            wereYou: userIsApplicant ? 'were you' : 'was ' + appName,
            haveYou: userIsApplicant ? 'have you' : 'has ' + appName,
            your: userIsApplicant ? 'your' : appName + `'s`,
        }
    }

    // MUTATION HANDLERS
    const getDefaultReturnItems = (name) => {
        const defaultReturnItems = [
            '_lastChangedAt', '_deleted', 'createdAt', 'updatedAt'
        ]
        if (name.startsWith('User')) {
            defaultReturnItems.push('readAccessGroup', 'editAccessGroup', 'owner')
        }
        const vital = vitalAttributesForSync[name]
        if (vital && vital.length) {
            vital.forEach(v => {
                if (!defaultReturnItems.includes(v)) {
                    defaultReturnItems.push(v)
                }
            })
        }
        return defaultReturnItems
    }

    async function reversibleUpdate(update) {
        console.log({reversible:update})
        // get orig values of what is about to be updated
        let orig = update.origPairs
        // save them to the server
        try {

            const variables = {
                input: {
                    id: update.id,
                    _version: update._version, ...update.pairs
                }
            }

            const mutationName = 'Update' + update.name
            const defaultReturnItems = getDefaultReturnItems(update.name)

            const itemString = buildSelection(
                variables.input,
                defaultReturnItems,
                update.name
            )
            // const itemString = [
            //     ...Object.keys(variables.input), ...defaultReturnItems
            // ].join('\n')


            const query = generateMutation(mutationName, itemString)

            const result = await performGQLWithConflictRetry(variables, query)
            setMortgage(s => {

                let {
                    id,
                    ...rest
                } = result

                setItemFromPath(s, update.path, rest, 'objectMerge')
                return s
            })
            return result
        } catch (e) {
            console.log('Sorry! I have to undo that because ' + e.message)
            setMortgage(prevMortgage => {

                let copy = {...prevMortgage}
                setItemFromPath(copy, update.path, orig, 'objectMerge')
                app.message.error('Request failed! Your changes did not save')
                return copy
            })
        }
    }

    async function reversibleCreate(creation) {
        // save object to the server

        const variables = {
            input: {
                ...creation.pairs,
                id: creation.id
            }
        }
        const mutationName = 'Create' + creation.name
        const defaultReturnItems = getDefaultReturnItems(creation.name)
        if (!defaultReturnItems.includes('_version')) {
            defaultReturnItems.push('_version')
        }
        if (!defaultReturnItems.includes('id')) {
            defaultReturnItems.push('id')
        }
        if (!defaultReturnItems.includes('_lastChangedAt')) {
            defaultReturnItems.push('_lastChangedAt')
        }
        const itemString = buildSelection(
            variables.input,
            defaultReturnItems,
            creation.name
        )
        // const itemString = [
        //     ...Object.keys(variables.input), ...defaultReturnItems
        // ].join('\n')

        const query = generateMutation(mutationName, itemString)

        // on success replace the old object
        try {

            const result = await performGQL(variables, query)
            setMortgage(prevState => {
                let updatedState = {...prevState}
                let array = getItemFromPath(updatedState, creation.path).map(item => {
                    if (item.id === creation.id) {
                        return result
                    }
                    return item
                })
                setItemFromPath(updatedState, creation.path, array)
                return updatedState
            })

            return result
        }
            // on failure delete the old object
        catch (e) {
            app.message.error('Request failed! Your item did not save')
            console.log(e)
            setMortgage(prevState => {
                let updatedState = {...prevState}
                let array = getItemFromPath(updatedState, creation.path).filter(item => {
                    return item.id !== creation.id;
                })
                setItemFromPath(updatedState, creation.path, array)
                return updatedState
            })
        }
    }

    async function reversibleDelete(deletion) {

        const mutationName = 'Delete' + deletion.name
        const defaultReturnItems = getDefaultReturnItems(deletion.name)
        if (!defaultReturnItems.includes('id')) {
            defaultReturnItems.push('id')
        }
        if (!defaultReturnItems.includes('_version')) {
            defaultReturnItems.push('_version')
        }
        const query = generateMutation(mutationName, defaultReturnItems.join('\n'))
        const variables = {
            input: {
                id: deletion.origItem.id,
                _version: deletion.origItem._version
            }
        }
        try {
            await performGQLWithConflictRetry(variables, query)
        }
            // on failure put back the old object
        catch (e) {
            console.log(e)
            setMortgage(prevState => {

                let updatedState = {...prevState}
                console.log({lev:deletion.path})
                let {type: path} = extractTypeAndId(deletion.path)
                let array = getItemFromPath(updatedState, path)

                setItemFromPath(updatedState, path, [
                    ...array, deletion.origItem
                ])
                app.message.error('Request failed! Your item did not delete')
                return updatedState
            })
        }
    }

    // Planning reads the latest mortgage (latestMortgage ref) and returns the
    // details of what to change. It must not touch state or fire requests, so
    // the setMortgage updaters below stay pure and the requests are started
    // synchronously - mutate() can then reliably await them.
    const planUpdate = (mortgageState, update) => {

        /*
       updates = [
           {
           target: 'applicant1.personal.dateOfBirth',
           value: newValue,
           type: (optional) type of question that will do conversions prior to saving
           }
       ]
        */

        const modelsToUpdate = {}
        console.log('optimisticUpdate', update)

        function addFieldToModelsToUpdate(field) {
            // only adds a promise to update the db and mortgage if the value has changed
            if (typeof field.target === "function") {
                field.target = field.target(mortgageState)
            }

            // if passed pairs props and model target
            if (field.hasOwnProperty('pairs')) {
                Object.keys(field.pairs).forEach(key => {
                    addFieldToModelsToUpdate({
                        target: `${field.target}.${key}`,
                        value: field.pairs[key]
                    })
                })
            } else {

                // if passed a value prop and full target
                let parts = field.target.split('.')
                let column = parts.pop()
                let path = parts.join('.')
                let modelName = 'mortgage.' + path

                let model = getItemFromPath(mortgageState, path)
                try {
                    let oldFieldValue = model[column]
                    let newFieldValue = field.value
                    if (JSON.stringify(oldFieldValue) !== JSON.stringify(newFieldValue)) {
                        if (!modelsToUpdate.hasOwnProperty(modelName)) {
                            modelsToUpdate[modelName] = {
                                id: model.id,
                                pairs: {},
                                origPairs: {},
                                path: path,
                                name: getModelName(path),
                                _version: model._version,
                            }
                        }
                        modelsToUpdate[modelName].pairs[column] = newFieldValue
                        modelsToUpdate[modelName].origPairs[column] = oldFieldValue
                    }
                } catch (e) {
                    console.log(`Error getting old field value [${modelName}]`)
                }


            }
        }

        if (Array.isArray(update)) {
            update.forEach((field, i) => {
                addFieldToModelsToUpdate(field)
            })
        } else {
            addFieldToModelsToUpdate(update)
        }
        return Object.values(modelsToUpdate)
    }
    const applyUpdates = (mortgageState, updates) => {
        let state = mortgageState
        updates.forEach(updateDetails => {
            state = cloneAlongPath(state, updateDetails.path)
            setItemFromPath(state, updateDetails.path, updateDetails.pairs, 'objectMerge')
        })
        return state
    }
    const planDelete = (mortgageState, deletion) => {
        const modelsToDelete = []

        function addFieldToModelsToDelete(field) {
            if (typeof field.target === "function") {
                field.target = field.target(mortgageState)
            }
            let origItem = getItemFromPath(mortgageState, `${field.target}[${field.id}]`)

            let tempObject = {
                path: field.target,
                name: getModelName(field.target),
                origItem
            }

            modelsToDelete.push(tempObject)
        }

        if (Array.isArray(deletion)) {
            deletion.forEach((field, i) => {
                addFieldToModelsToDelete(field)
            })
        } else {
            addFieldToModelsToDelete(deletion)
        }
        return modelsToDelete
    }
    const applyDeletes = (mortgageState, deletes) => {
        let state = mortgageState
        deletes.forEach(deleteDetails => {
            state = cloneAlongPath(state, deleteDetails.path)
            let array = getItemFromPath(state, deleteDetails.path)
            let arrayWithoutDeleted = array.filter(item => item.id !== deleteDetails.origItem.id)
            setItemFromPath(state, deleteDetails.path, arrayWithoutDeleted)
        })
        return state
    }
    const planCreate = (mortgageState, creation) => {
        // create temp object in the state
        // create on the server
        // on error, delete the temp object
        // on success, replace the temp object with the real one,

        const modelsToCreate = []

        function addFieldToModelsToCreate(field) {
            if (typeof field.target === "function") {
                field.target = field.target(mortgageState)
            }
            let path = field.target

            // create a new temporary object with fake id and add it to mortgage
            let newId = field.pairs.hasOwnProperty('id') ? field.pairs.id : v4()

            const tempObject = {
                id: newId,
                pairs: field.pairs,
                path: path,
                name: getModelName(path),
                createdAt: (new Date()).toISOString(),
            }
            if (tempObject.name.startsWith('User')) {
                if (!tempObject.pairs.hasOwnProperty('readAccessGroup')) {
                    tempObject.pairs.readAccessGroup = readAccessGroup(mortgageState, path)
                }
                if (!tempObject.pairs.hasOwnProperty('editAccessGroup')) {
                    tempObject.pairs.editAccessGroup = editAccessGroup(mortgageState, path)
                }
            }

            modelsToCreate.push(tempObject)
        }

        if (Array.isArray(creation)) {
            creation.forEach((field, i) => {
                addFieldToModelsToCreate(field)
            })
        } else {
            addFieldToModelsToCreate(creation)
        }
        return modelsToCreate
    }
    const applyCreates = (mortgageState, creates) => {
        let state = mortgageState
        creates.forEach(createDetails => {
            let fakeObject = {
                id: createDetails.id,
                createdAt: createDetails.createdAt, // _version: 1,
                ...createDetails.pairs
            }
            state = cloneAlongPath(state, createDetails.path)
            setItemFromPath(state, createDetails.path, fakeObject, 'arrayAdd')
        })
        return state
    }
    const applyPlan = (mortgageState, plan) => {
        let state = applyUpdates(mortgageState, plan.updates)
        state = applyCreates(state, plan.creates)
        return applyDeletes(state, plan.deletes)
    }
    const optimisticMutate = async (obj, callback) => {
        const current = latestMortgage.current
        const plan = {
            updates: obj?.update ? planUpdate(current, obj.update) : [],
            creates: obj?.create ? planCreate(current, obj.create) : [],
            deletes: obj?.delete ? planDelete(current, obj.delete) : [],
        }

        // Immediately update the local mortgage...
        setMortgage(prevMortgage => applyPlan(prevMortgage, plan))
        // ...so a second mutate() before the next render plans against it
        latestMortgage.current = applyPlan(current, plan)

        // ...and save to server
        const promises = [
            ...plan.updates.map(reversibleUpdate),
            ...plan.creates.map(reversibleCreate),
            ...plan.deletes.map(reversibleDelete),
        ]
        try {
            const resultArray = await Promise.all(promises)
            if (typeof callback === 'function') {
                callback()
            }
            return resultArray
        } catch (e) {
            console.log(e)

        }
    }
    const localMutate = (obj) => {
        if (!obj?.update) {
            return
        }
        setMortgage(prevMortgage => applyUpdates(prevMortgage, planUpdate(prevMortgage, obj.update)))
    }

    // RENDER
    useEffect(() => {
        if (!mortgage) {
            fetchMortgage()
        }
        return () => {
            app.notification.destroy()
        }
    }, [mortgage.id])
    const timer = useRef(null)
    useEffect(() => {
        if (allSectionsLoaded) {
            sidebar.setMortgage(mortgage)
        }
    }, [allSectionsLoaded]);
    const getMortgageValue = () => {

        let app1incomes = mortgage.applicant1.employmentIncome?.length ? mortgage.applicant1.employmentIncome.map(item => ({
            ...item,
            incomes: item.incomes ? JSON.parse(item.incomes) : undefined
        })) : undefined
        let app2incomes = mortgage.applicant2.employmentIncome?.length ? mortgage.applicant2.employmentIncome.map(item => ({
            ...item,
            incomes: item.incomes ? JSON.parse(item.incomes) : undefined
        })) : undefined

        const applicantKeys = mortgage.flipApplicants ? ['applicant2', 'applicant1'] : ['applicant1', 'applicant2']
        let betterMortgage = {
            ...mortgage,
            [applicantKeys[0]]: {
                ...mortgage.applicant1,
                employmentIncome: app1incomes,
                strings: applicantStrings(mortgage.applicant1),
                fullName: capitaliseWords(`${mortgage.applicant1.firstName} ${mortgage.applicant1.surname || ''}`.trim()),
                age: ageFromDate(mortgage.applicant1.personal.dateOfBirth)
            },
            [applicantKeys[1]]: {
                ...mortgage.applicant2,
                employmentIncome: app2incomes,
                strings: applicantStrings(mortgage.applicant2),
                fullName: capitaliseWords(`${mortgage.applicant2.firstName} ${mortgage.applicant2.surname || ''}`.trim()),
                age: ageFromDate(mortgage.applicant2.personal.dateOfBirth)
            },
        }
        const submissions = mortgage.submissions.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt)
        }).map(item => {
            return {
                ...item,
                completedFlowItems: JSON.parse(item.completedFlowItems || '{}'),
                completedFlowItemsForAdmin: JSON.parse(item.completedFlowItemsForAdmin || '{}'),
                provisionalXlsOutput: item.provisionalXlsOutput ? JSON.parse(item.provisionalXlsOutput) : null,
                provisionalXlsInput: item.provisionalXlsInput ? JSON.parse(item.provisionalXlsInput) : null,
                aipSettings: JSON.parse(item?.aipSettings || '{}'),
                loanOfferSettings: JSON.parse(item?.loanOfferSettings || '{}')
            }
        })
        const activeSubmission = submissions.length ? submissions[0] : null
        const _getAccountNumbers = () => {
            let accountNumbers = []
            const getRecord = (name, index) => {
                return mortgage.progress.find(item => {
                    if (item.deleted) {
                        return false
                    }
                    if (item.sectionType === 'UPLOAD' && item.applicationStage === 'APPLY' && item.sectionName === name) {
                        if (index) {
                            return item.sectionIndex === index
                        }
                        return true
                    }
                    return false
                })
            }
            mortgage.applicant1.accounts.forEach(account => {
                const record = getRecord('current-accounts-1', account.index)
                if (!record || record?.viewState !== ProgressViewState.HIDDEN) {
                    accountNumbers.push({
                        source: account.institution,
                        applicant: 1,
                        accountNumber: account.accountNumber
                    })
                }

            })
            mortgage.applicant1.assets.forEach(asset => {
                const record = getRecord('assets-1', asset.index)
                if (!record || record?.viewState !== ProgressViewState.HIDDEN) {
                    accountNumbers.push({
                        source: asset.description || asset.institution,
                        applicant: 1,
                        accountNumber: asset.accountNumber
                    })
                }
            })
            if (mortgage.twoApplicants) {

                mortgage.applicant2.accounts.forEach(account => {
                    const record = getRecord('current-accounts-2', account.index)
                    if (!record || record?.viewState !== ProgressViewState.HIDDEN) {
                        accountNumbers.push({
                            source: account.institution,
                            applicant: 2,
                            accountNumber: account.accountNumber
                        })
                    }
                })
                mortgage.applicant2.assets.forEach(asset => {
                    const record = getRecord('assets-2', asset.index)
                    if (!record || record?.viewState !== ProgressViewState.HIDDEN) {
                        accountNumbers.push({
                            source: asset.description || asset.institution,
                            applicant: 2,
                            accountNumber: asset.accountNumber
                        })
                    }
                })
            }
            return accountNumbers
        }
        const getAppLastHere = (n) => {
            let index = `applicant${n}`
            const lH = betterMortgage[index]?.lastHereTime?.time ? new Date(betterMortgage[index]?.lastHereTime?.time) : false
            return lH
        }

        let lh1 = getAppLastHere(1)
        let lh2 = getAppLastHere(2)
        const dates = [
            lh1, lh2
        ].filter(Boolean);
        // Find the most recent date using Math.max() and the spread operator
        if (dates.length) {
            const mostRecentDate = new Date(Math.max(...dates));
            betterMortgage.lastHere = mostRecentDate.toISOString()
        }
        const sortedProperties = (betterMortgage.properties || []).sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt)
        })
        const property = sortedProperties.length ? sortedProperties[0] : null
        return {
            ...betterMortgage,
            completedFlowItems: JSON.parse(mortgage.completedFlowItems || '{}'),
            completedFlowItemsForAdmin: JSON.parse(mortgage.completedFlowItemsForAdmin || '{}'),
            completedFlowHiddenItems: JSON.parse(mortgage.completedFlowHiddenItems || '{}'), //     analysedSections          : mortgage.analysedSections.map(item => ({...item, chatGptResponse: JSON.parse(item.chatGptResponse || '{}')})),
            completedFlowItemsMeta: JSON.parse(mortgage.completedFlowItemsMeta || '{}'),
            requirement: {
                ...mortgage.requirement,
                proposals: JSON.parse(mortgage.requirement.proposals || '{}'),
                accountingFx: JSON.parse(mortgage.requirement.accountingFx || '{}'),
                //gifters: JSON.parse(mortgage.requirement.gifters || '[]'),
            },
            progress: mortgage.progress.map(item => {
                return {
                    ...item,
                    verifiedData: JSON.parse(item?.verifiedData || '{}'),
                }
            }),
            lenderTests: mortgage.playgroundTests.flatMap(item => {
                let results = JSON.parse(item.results || '{}')
                let data = JSON.parse(item.data || '{}')
                let lenders = Object.keys(data)
                if (!lenders.length) {
                    return []
                }
                if (!data.hasOwnProperty('figures')) {
                    return []
                }
                return [
                    {
                        ...item,
                        results,
                        data
                    }
                ]
            }),
            playgroundTests: mortgage.playgroundTests.filter(item => {

                let data = JSON.parse(item.data || '{}')
                let lenders = Object.keys(data)
                if (!lenders.length) {
                    return false
                }
                if (data.hasOwnProperty('figures')) {
                    return false
                }
                return true
            }),
            lostUploads: mortgage.uploads.filter(it => it.status === 'PENDING' || it.status === 'REVIEWING'),
            applicationTitle: betterMortgage.applicant1.fullName + (betterMortgage.twoApplicants ? ' & ' + betterMortgage.applicant2.fullName : ''),
            submissions,
            mutate: optimisticMutate,
            localMutate: localMutate,
            activeSubmission: !!activeSubmission ? expandActiveSubmission(activeSubmission) : null,
            setMortgage,
            bankAccountNumbers: _getAccountNumbers(),
            applicationStage: betterMortgage.applicationStage,
            properties: sortedProperties,
            property
        }
    }
    const lastSeenUpdated = useRef(null)
    useEffect(() => {
        if (!lastSeenUpdated.current && !!allSectionsLoaded) {

            lastSeenUpdated.current = true
            optimisticMutate({
                update: {
                    target: 'lastSeen',
                    value: new Date().toISOString()
                }
            })
        }

    }, [allSectionsLoaded]);
    useEffect(() => {
        const onUpdateUserMortgageUploads = /* GraphQL */ `
            subscription OnUpdateUserMortgageUploads(
                $filter: ModelSubscriptionUserMortgageUploadsFilterInput
                $owner: String
            ) {
                onUpdateUserMortgageUploads(filter: $filter, owner: $owner) {
                    id
                    contentType
                    fileName
                    fileSize
                    fileExtension
                    stage
                    section
                    index
                    status
                    statusBy
                    statusOn
                    mortgageID
                    observeMID
                    reason
                    identityID
                    stampedOn
                    analysisJobStatus
                    analysisErrors
                    processedAnalysis
                    pdffed
                    seenOn
                    seenBy
                    omit
                    exclude
                    logicalName
                    examined
                    readAccessGroup
                    editAccessGroup
                    verifiable
                    createdAt
                    updatedAt
                    _version
                    _deleted
                    _lastChangedAt
                    owner
                }
            }
        `;

        const subscription = API.graphql(graphqlOperation(onUpdateUserMortgageUploads, {filter: {mortgageID: {eq: props.id}}})).subscribe({
            next: ({value}) => {

                const newUpload = value.data.onUpdateUserMortgageUploads;

                setMortgage(s => ({
                    ...s,
                    uploads: s.uploads.map(u => u.id === newUpload.id ? {...u, ...newUpload} : u)
                }))
            },
            error: (error) => console.warn(error),
        });

        return () => {
            subscription.unsubscribe();
        }
    }, []);
    // Keeps mortgage.uploads[].balances.items live once
    // extractStatementBalances (or a manual BalancesForm.jsx edit, in
    // another admin's own tab) writes/updates/deletes a row - nothing else
    // refetches the mortgage after that, so without this every reader of
    // upload.balances (BankingSavingsRate/WealthTables/StatementAlignment
    // via useBankingSavingsRate, AccountsListWithStatementRange via
    // useAccountsStatements, BalancesForm itself) would keep showing the
    // snapshot from this mortgage's own initial getMortgage load.
    //
    // UserMortgageUploadStatementBalance has no mortgageID of its own (only
    // uploadID), so this can't filter by mortgageID the way
    // onUpdateUserMortgageUploads above does - filters on the uploadIDs
    // already known for this mortgage instead. Depends on that id list
    // (not []) because mortgage.uploads isn't populated yet at first mount
    // (mortgage starts as `false` - see the useState above) - subscribing
    // before then would filter on an empty list and silently miss every
    // event.
    const uploadIDs = mortgage && mortgage !== 'fetching' ? mortgage.uploads.map(u => u.id) : []
    const uploadIDsKey = uploadIDs.join(',')
    useEffect(() => {
        if (!uploadIDsKey) return

        const BALANCE_FIELDS = `
            id
            uploadID
            date
            balance
            balanceBoundary
            dirty
            _version
            _deleted
        `;
        // No $filter argument at all, deliberately - AppSync's own
        // "Enhanced Subscription Filtering" has real, documented rough
        // edges on multi-auth-mode @model types like this one (owner +
        // {allow: private, provider: iam} for sussdInvoker's own writes +
        // groups): a row with no Cognito owner (everything sussdInvoker
        // writes) can silently fail to reach a Cognito-subscribed listener
        // through the filtered variant, with no client-side error at all -
        // confirmed as the likely cause after the filtered version never
        // delivered a single event for sussdInvoker-authored rows
        // (2026-09-29). Subscribing to every event and filtering
        // client-side in upsertBalance below sidesteps that class of bug
        // entirely - the cost (every open admin tab receives every
        // balance event system-wide, not just its own mortgage's uploads)
        // is cheap at this app's scale.
        const onCreateBalance = /* GraphQL */ `
            subscription OnCreateUserMortgageUploadStatementBalance {
                onCreateUserMortgageUploadStatementBalance { ${BALANCE_FIELDS} }
            }
        `;
        const onUpdateBalance = /* GraphQL */ `
            subscription OnUpdateUserMortgageUploadStatementBalance {
                onUpdateUserMortgageUploadStatementBalance { ${BALANCE_FIELDS} }
            }
        `;
        const onDeleteBalance = /* GraphQL */ `
            subscription OnDeleteUserMortgageUploadStatementBalance {
                onDeleteUserMortgageUploadStatementBalance { ${BALANCE_FIELDS} }
            }
        `;

        const uploadIDSet = new Set(uploadIDsKey.split(','))
        const upsertBalance = (newBalance) => {

            if (!newBalance || !uploadIDSet.has(newBalance.uploadID)) return
            setMortgage(s => ({
                ...s,
                uploads: s.uploads.map(u => {
                    if (u.id !== newBalance.uploadID) return u
                    const items = u.balances?.items ?? []
                    const withoutExisting = items.filter(b => b.id !== newBalance.id)
                    const nextItems = newBalance._deleted ? withoutExisting : [...withoutExisting, newBalance]
                    return {...u, balances: {...u.balances, items: nextItems}}
                })
            }))
        }

        const subscriptions = [
            API.graphql(graphqlOperation(onCreateBalance)).subscribe({
                next: ({value}) => upsertBalance(value.data.onCreateUserMortgageUploadStatementBalance),
                error: (error) => console.warn(error),
            }),
            API.graphql(graphqlOperation(onUpdateBalance)).subscribe({
                next: ({value}) => upsertBalance(value.data.onUpdateUserMortgageUploadStatementBalance),
                error: (error) => console.warn(error),
            }),
            API.graphql(graphqlOperation(onDeleteBalance)).subscribe({
                next: ({value}) => upsertBalance({...value.data.onDeleteUserMortgageUploadStatementBalance, _deleted: true}),
                error: (error) => console.warn(error),
            }),
        ]

        return () => {
            subscriptions.forEach(s => s.unsubscribe())
        }
    }, [uploadIDsKey]);


    // Keeps mortgage.uploads[].verifiedData.items live once
    // extractStatementSummary (sussdInvoker, no admin identity) writes an
    // iban/startDate/endDate point - nothing else refetches the mortgage
    // after that, so InstaVerifiedDataPoint/MyLittleForm would keep showing
    // whatever this mortgage's own initial getMortgage load had until a
    // manual refresh. AdminMortgageUploadVerifiedPoint used to be
    // @model(subscriptions: null) - subscriptions are only enabled on this
    // type now (2026-09-29) specifically for this.
    //
    // Filters on uploadID, not mortgageID, even though the row has its own
    // mortgageID field - submitVerifiedDataFields's own create path
    // (submit-data.js) never sets it, so it's null on every point this
    // feature creates. uploadID is always present, and already known for
    // this mortgage the same way the balance subscription above uses it.
    // No $filter argument, for the same reason the balance subscription
    // above has none - this type now mixes owner/group auth with
    // {allow: private, provider: iam} for sussdInvoker's own writes, the
    // same combination that silently dropped filtered events for
    // IAM-authored balance rows.
    useEffect(() => {
        if (!uploadIDsKey) return

        const POINT_FIELDS = `
            id
            uploadID
            mortgageID
            name
            verifiedValue
            verifiedValueType
            verificationOn
            verificationBy
            supervisorCheckRequired
            supervisorCheckOn
            supervisorCheckBy
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
        `;
        const onCreatePoint = /* GraphQL */ `
            subscription OnCreateAdminMortgageUploadVerifiedPoint {
                onCreateAdminMortgageUploadVerifiedPoint { ${POINT_FIELDS} }
            }
        `;
        const onUpdatePoint = /* GraphQL */ `
            subscription OnUpdateAdminMortgageUploadVerifiedPoint {
                onUpdateAdminMortgageUploadVerifiedPoint { ${POINT_FIELDS} }
            }
        `;
        const onDeletePoint = /* GraphQL */ `
            subscription OnDeleteAdminMortgageUploadVerifiedPoint {
                onDeleteAdminMortgageUploadVerifiedPoint { ${POINT_FIELDS} }
            }
        `;

        const uploadIDSet = new Set(uploadIDsKey.split(','))
        // verificationNotes isn't in POINT_FIELDS (a separate hasMany
        // connection, not worth a second live-update mechanism here) - kept
        // from whatever's already in state for an existing point, defaulted
        // to an empty list for a genuinely new one so MyLittleForm's own
        // `manager.data.verificationNotes.items.length` never sees undefined.
        const upsertVerifiedPoint = (newPoint) => {
            if (!newPoint || !uploadIDSet.has(newPoint.uploadID)) return
            setMortgage(s => ({
                ...s,
                uploads: s.uploads.map(u => {
                    if (u.id !== newPoint.uploadID) return u
                    const items = u.verifiedData?.items ?? []
                    const existing = items.find(p => p.id === newPoint.id)
                    const withoutExisting = items.filter(p => p.id !== newPoint.id)
                    const merged = existing
                        ? {...existing, ...newPoint}
                        : {verificationNotes: {items: []}, ...newPoint}
                    const nextItems = newPoint._deleted ? withoutExisting : [...withoutExisting, merged]
                    return {...u, verifiedData: {...u.verifiedData, items: nextItems}}
                })
            }))
        }

        const subscriptions = [
            API.graphql(graphqlOperation(onCreatePoint)).subscribe({
                next: ({value}) => upsertVerifiedPoint(value.data.onCreateAdminMortgageUploadVerifiedPoint),
                error: (error) => console.warn(error),
            }),
            API.graphql(graphqlOperation(onUpdatePoint)).subscribe({
                next: ({value}) => upsertVerifiedPoint(value.data.onUpdateAdminMortgageUploadVerifiedPoint),
                error: (error) => console.warn(error),
            }),
            API.graphql(graphqlOperation(onDeletePoint)).subscribe({
                next: ({value}) => upsertVerifiedPoint({...value.data.onDeleteAdminMortgageUploadVerifiedPoint, _deleted: true}),
                error: (error) => console.warn(error),
            }),
        ]

        return () => {
            subscriptions.forEach(s => s.unsubscribe())
        }
    }, [uploadIDsKey]);



    const mortgageValue = mortgage && mortgage !== 'fetching' && allSectionsLoaded ? getMortgageValue() : false

    if (!mortgageValue) {
        return <Skeleton loading={true}/>
    }

    return <Mortgage.Provider value={mortgageValue}>
        {props.children}
        <Repairs mortgage={mortgageValue}/>
    </Mortgage.Provider>
}

export default MortgageProvider

function Repairs({mortgage}) {

    const createUserApplicantHealth = /* GraphQL */ `
        mutation CreateUserApplicantHealth(
            $input: CreateUserApplicantHealthInput!
            $condition: ModelUserApplicantHealthConditionInput
        ) {
            createUserApplicantHealth(input: $input, condition: $condition) {
                id
                weight
                height
                smoker
                everSmoked
                stoppedSmokingDate
                alcoholUnits
                dangerousActivities
                familyDeath
                diagnosedConditions
                diagnosedConditionsDetails
                prescribedMedication
                prescribedMedicationDetails
                hasGp
                gpName
                gpAddress
                gpLastVisit
                yearsWithGp
                earlyUnderwriting
                readAccessGroup
                editAccessGroup
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
                __typename
            }
        }
    `;
    const repairHealth = async () => {

        let promises = []
        if (!mortgage.applicant1.health) {
            promises.push(performGQL({
                input: {
                    id: mortgage.applicant1.id,
                    readAccessGroup: [`${mortgage.id}-app2`],
                    editAccessGroup: [
                        `${mortgage.id}-app1`, `${mortgage.applicant1.id}-appId`
                    ],
                }
            }, createUserApplicantHealth))
            promises.push(performGQL({
                input: {
                    id: mortgage.applicant2.id,
                    readAccessGroup: [],
                    editAccessGroup: [
                        `${mortgage.id}-app1`, `${mortgage.id}-app2`, `${mortgage.applicant2.id}-appId`
                    ],
                }
            }, createUserApplicantHealth))
        }
        if (promises.length) {
            let result = await Promise.all(promises)
            mortgage.setMortgage(s => {
                return {
                    ...s,
                    applicant1: {
                        ...s.applicant1,
                        health: result[0]
                    },
                    applicant2: {
                        ...s.applicant2,
                        health: result[1]
                    }
                }
            })
        }
    }

    const repairCompletedFlowItemsForAdmin = async () => {

        let newVal = {...mortgage.completedFlowItemsForAdmin}

        let old_incompleteEmailSent = mortgage.stageTasks.find(item => item.name === 'setupIncomplete.email.initial')
        if (old_incompleteEmailSent) {
            if (!mortgage.completedFlowItemsForAdmin.hasOwnProperty('incompleteEmailSent')) {
                newVal.incompleteEmailSent = {
                    on: old_incompleteEmailSent.completedOn,
                    by: old_incompleteEmailSent.completedBy
                }
            }
        }

        let old_incompleteReminderEmailSent = mortgage.stageTasks.find(item => item.name === 'setupIncomplete.email.reminder1')
        if (old_incompleteReminderEmailSent) {
            if (!mortgage.completedFlowItemsForAdmin.hasOwnProperty('incompleteReminderEmailSent')) {
                newVal.incompleteReminderEmailSent = {
                    on: old_incompleteReminderEmailSent.completedOn,
                    by: old_incompleteReminderEmailSent.completedBy
                }
            }
        }

        let old_qualificationEmailSent = mortgage.stageTasks.find(item => item.name === 'sendQualificationEmail.email.initial')
        if (old_qualificationEmailSent) {

            if (!mortgage.completedFlowItemsForAdmin.hasOwnProperty('qualificationEmailSent')) {
                newVal.qualificationEmailSent = {
                    on: old_qualificationEmailSent.completedOn,
                    by: old_qualificationEmailSent.completedBy
                }
            }
        }

        let old_qualificationReminderEmailSent = mortgage.stageTasks.find(item => item.name === 'sendQualificationEmail.email.reminder1')
        if (old_qualificationReminderEmailSent) {
            if (!mortgage.completedFlowItemsForAdmin.hasOwnProperty('qualificationReminderEmailSent')) {
                newVal.qualificationReminderEmailSent = {
                    on: old_qualificationReminderEmailSent.completedOn,
                    by: old_qualificationReminderEmailSent.completedBy
                }
            }
        }

        let old_discussionEmailSent = mortgage.stageTasks.find(item => item.name === 'sendMoveToApplyEmail.email.initial')
        if (old_discussionEmailSent) {
            if (!mortgage.completedFlowItemsForAdmin.hasOwnProperty('discussionEmailSent')) {
                newVal.discussionEmailSent = {
                    on: old_discussionEmailSent.completedOn,
                    by: old_discussionEmailSent.completedBy
                }
            }
        }

        let old_discussionReminderEmailSent = mortgage.stageTasks.find(item => item.name === 'sendMoveToApplyEmail.email.reminder1')
        if (old_discussionReminderEmailSent) {
            if (!mortgage.completedFlowItemsForAdmin.hasOwnProperty('discussionReminderEmailSent')) {
                newVal.discussionReminderEmailSent = {
                    on: old_discussionReminderEmailSent.completedOn,
                    by: old_discussionReminderEmailSent.completedBy
                }
            }
        }

        let update = {
            target: 'completedFlowItemsForAdmin',
            value: JSON.stringify(newVal)
        }

        await mortgage.mutate({update})

    }

    useEffect(() => {
        if (!mortgage.applicant1.health) {
            repairHealth()
        }
        // repairCompletedFlowItemsForAdmin()
    }, []);
    useEffect(() => {
        const timer = setTimeout(async ()=>{
            if (mortgage.mortgageType === MortgageTypes.PURCHASE) return
            const {loanTerm, loanRequired} = mortgage.requirement||{}
            const {remainingTerm, outstanding} = mortgage.property||{}
            const updates = []
            if (outstanding !== loanRequired) {
                updates.push({
                    target: `requirement.loanRequired`,
                    value: outstanding
                })
            }
            if (remainingTerm !== loanTerm) {
                updates.push({
                    target: `requirement.loanTerm`,
                    value: remainingTerm
                })
            }
            if (updates.length){
                await  mortgage.mutate({update:updates})
            }
/*
            if (mortgage.id === "598d86b5-ffe4-40e8-9851-47c8f72dd513"){
                const uploads = mortgage.uploads
                console.log('uploads', uploads)
                const promises = uploads.filter(upload=>{
                    return dayjs(upload.createdAt).isAfter(dayjs('2025-06-01'))
                }).flatMap((upload,i) => {
                        const operations = []
                        const {__typename, id, mortgageID, updatedAt, _lastChangedAt, createdAt, observeMID, sortedBalances, _version, verifiedData, balances, verificationNotes, ...rest1} = upload
                        const newUpload = {
                            ...rest1,
                            id: v4(),
                            mortgageID: "a99d4445-9265-4724-8c05-7a9fa25fc025",
                            observeMID: "a99d4445-9265-4724-8c05-7a9fa25fc025",
                            _version: null
                        }
                        if (balances){
                            const bItems = balances.items
                            if (bItems?.length){
                                const newBalances = bItems.map(item => {
                                    const {__typename, _version, _deleted, id, uploadID, updatedAt, _lastChangedAt, createdAt, ...rest2} = item
                                    const nBalance = {
                                        ...rest2,
                                        id: v4(),
                                        uploadID: newUpload.id,
                                    }
                                    //return performGQL({input: nBalance}, createUserMortgageUploadStatementBalance)
                                    return {input:nBalance}

                                })
                                operations.push(...newBalances)
                            }
                        }
                        operations.push({newUpload})
                        if (verifiedData) {
                            const items = verifiedData.items
                            if (items?.length){
                                const newItems = items.map(item => {
                                    const {__typename, _version, _deleted, id, updatedAt, _lastChangedAt, createdAt, mortgageID, uploadID, verificationNotes, ...rest3} = item
                                    const input = {
                                        ...rest3,
                                        id: v4(),
                                        mortgageID: newUpload.mortgageID,
                                        uploadID: newUpload.id,
                                        _version: null,
                                    }
                                    return {input}
                                    //return performGQL({input}, createAdminMortgageUploadVerifiedPoint)
                                })
                                operations.push(...newItems)
                            } 
                        }
                        console.log({operations})
                        return newUpload

                })
                console.log("promises", promises)

            }
*/



        }, 1000)
        return ()=>clearTimeout(timer)
    },[mortgage.property?.outstanding, mortgage?.property?.remainingTerm, mortgage.mortgageType])
    return null
}